module.exports = "<button class=\"kd-icon kd-icon--light\"\r\n    type=\"button\"\r\n    title=\"Sincronizar información\"\r\n    ng-click=\"$ctrl.sync()\">\r\n  <i class=\"fa fa-sync\"\r\n      ng-class=\"{'fa-spin': $ctrl.processing}\"></i>\r\n</button>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/components/sync/template.html
// module id = 173
// module chunks = 0